// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export type { OutgoingHandler } from "./BufferScheduler-browser.mjs";
export { BufferScheduler } from "./BufferScheduler-browser.mjs";
